<div class="flex-row">
  <mat-form-field>
    <mat-label>Auth Token</mat-label>
    <input matInput placeholder="Type valid JWT here" [formControl]="tokenFormControl">
  </mat-form-field>
</div>
